import { itiHttpService, itiMessageService, itiTokenService } from '@/iti-core-vue';
import { ItiIconButton, ItiVHeader, ItiList } from '@/iti-core-vuetify';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';
import { Component, Vue } from "vue-property-decorator";
import DxButton from 'devextreme-vue/button';
import DxDataGrid, {DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';
import NextEvents from '@/components/next_events/next_events.vue';
import LastFiles from '@/components/last_files/last_files.vue';
import moment from 'moment';
import fileModule from '@/store/modules/file.module';
import { FileInfo } from '@/shared/dtos/fileInfo';

@Component({
  components: {    
    ItiIconButton,       
    DxButton,     
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    NextEvents,
    LastFiles,
  }
})
export default class CollaborativeAreaInfo extends Vue { 
    
    public pageSize: number = 10;
    public initRoute = "";
    public idType = 0;
    public areaTypeName = "";
    public areasActive = true;

    public get collaborativeAreas() {        
        return collaborativeAreaModule.collaborativeAreasInfo;
    }

    public get isAdmin() {
        return itiTokenService.getDecodedToken().role[2] == 'admin';
    }

    public get title() {
        return this.areaTypeName;
    }

    public async created() {
        var areaType =  this.$router.currentRoute.name;
        if(areaType) {
            this.initRoute = areaType;            
            this.areasActive ? this.activeCollaborativeAreaType(areaType) : this.inactiveCollaborativeAreaType(areaType);
        }                      
    }

    public beforeUpdate() {            
        var areaType =  this.$router.currentRoute.name;
        if (areaType && this.initRoute != areaType ) {
            this.initRoute = areaType;            
            this.areasActive ? this.activeCollaborativeAreaType(areaType) : this.inactiveCollaborativeAreaType(areaType);
        }        
    }

    public getDate(data: any) {         
        if (data.value.toString().charAt(0) == '0') { 
            return "";
        } else {
            return moment(data.value).format('DD-MM-YYYY HH:mm');
        }
    }

    public getNextEventDate(date: Date) {         
        if (date.toString().charAt(0) == '0') { 
            return "";
        } else {
            return  moment(date).format('DD-MM-YYYY');
        }
    }

    public getNextEventHour(data: any) {       
        if (data.nextEventDate.toString().charAt(0) == '0' || data.allDay) { 
            return "";
        } else {
            return '(' + moment(data.nextEventDate).format('HH:mm') + ')';
        }
    }

    public goToCollaborativeAreaDetails(e: any){                  
        this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: e.key.id } });
    }

    public goToFile(e: any) {
        var file ={ id: e.key.lastFileId, ambitId: e.key.id}
        fileModule.setFileToShow(file);
        this.$router.push('area-colaborativa-gestion-documental/' + e.key.id);
    }

    public goToChat(e: any) {        
        this.$router.push('chat-una-sala/' + e.key.id);
    }

    public goToForum(e: any) {        
        this.$router.push({ name: 'Foro-Post', params: { ambitId: e.key.id, postId: e.key.lastPostId } });
    }    

    public goToNextEvent(e: any) {                
        this.$router.push('calendario/' + e.key.id);
    }
    
    public activeCollaborativeAreaType(areaType: string) {
        switch(areaType) {
            case 'areasPublicas': {                                    
                collaborativeAreaModule.getActiveCollaborativeAreasInfoByType(0).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                this.idType = 0;
                this.areaTypeName = this.$tc('collaborative-area.publicArea');
                break;
            }
            case 'gruposTrabajo': {                                                            
                collaborativeAreaModule.getActiveCollaborativeAreasInfoByType(1).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                this.idType = 1;
                this.areaTypeName = this.$tc('collaborative-area.workGroups');
                break;
            }
            case 'areasColaborativas': {                    
                collaborativeAreaModule.getActiveCollaborativeAreasInfoByType(2).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                this.idType = 2;
                this.areaTypeName = this.$tc('collaborative-area.collaborativeAreas');
                break;
            }
        } 
    }

    public inactiveCollaborativeAreaType(areaType: string) {
        switch(areaType) {
            case 'areasPublicas': {                                    
                collaborativeAreaModule.getInactiveCollaborativeAreasInfoByType(0).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                this.idType = 0;
                this.areaTypeName = this.$tc('collaborative-area.publicArea');
                break;
            }
            case 'gruposTrabajo': {                                                            
                collaborativeAreaModule.getInactiveCollaborativeAreasInfoByType(1).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                this.idType = 1;
                this.areaTypeName = this.$tc('collaborative-area.workGroups');
                break;
            }
            case 'areasColaborativas': {                    
                collaborativeAreaModule.getInactiveCollaborativeAreasInfoByType(2).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                this.idType = 2;
                this.areaTypeName = this.$tc('collaborative-area.collaborativeAreas');
                break;
            }
        } 
    }

    public showActiveInactiveAreas() {
        this.areasActive = !this.areasActive;
        this.areasActive ? this.activeCollaborativeAreaType(this.initRoute) : this.inactiveCollaborativeAreaType(this.initRoute);
    }

    public get textActiveInactiveAreas() {
        if (this.areasActive) {
            return this.$tc('collaborative-area.showInactive');
        } else {
            return this.$tc('collaborative-area.showActive');
        }
    }

    public newCollaborativeArea() {        
        this.$router.push({ name: 'CollaborativeAreaForm', params: { id: '0' } });
    }    

}